module.exports = __webpack_public_path__ + "static/media/LUBRICANTS White@3x.865a7c84.png";